module.exports = __webpack_public_path__ + "static/img/Noise_NK.aaa1fd8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/handshakes/assets/Noise_NK.png
// module id = mG7W
// module chunks = 1